// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify, ThemeDefinition } from "vuetify";
import Vue3EasyDataTable from "vue3-easy-data-table";

import elevateIcon from "@/customIcons/elevateIcon.vue";
import command24Icon from "@/customIcons/command24Icon.vue";
import patch24Icon from "@/customIcons/patch24Icon.vue";
import { aliases, mdi } from "vuetify/iconsets/mdi";
//import type { IconSet, IconProps } from "vuetify";
import { h } from "vue";
import { IconProps } from "vuetify";
import { IconSet } from "vuetify";

const customSvgNameToComponent: any = {
  elevateIcon,
  command24Icon,
  patch24Icon,
};

const customSVGs: any = {
  component: (props: any) => h(customSvgNameToComponent[props.icon]),
};

const aliasesCustom = {
  ...aliases,
  elevateIcon,
  command24Icon,
  patch24Icon,
};

// const myCustomLightTheme: ThemeDefinition = {
//   dark: false,
//   colors: {
//     background: "#FFFFFF",
//     surface: "#FFFFFF",
//     primary: "#6200EE",
//     "primary-darken-1": "#3700B3",
//     secondary: "#03DAC6",
//     "secondary-darken-1": "#018786",
//     error: "#B00020",
//     info: "#2196F3",
//     success: "#4CAF50",
//     warning: "#FB8C00",
//   },
// };

// Jigsaw Orange = #e7541e

export default createVuetify({
  icons: {
    defaultSet: "mdi",
    // aliases: {
    //   ...aliasesCustom,
    // },
    sets: {
      mdi,
      custom: customSVGs,
    },
  },
  theme: {
    defaultTheme: "jigsawLight",
    themes: {
      myCustomLightTheme: {
        dark: false,
        colors: {
          background: "#ffffff",
          surface: "#000000",
          primary: "#6200EE",
          "primary-darken-1": "#3700B3",
          secondary: "#e7541e",
          "secondary-darken-1": "#018786",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
      },

      jigsawDark: {
        dark: true,
        colors: {
          background: "#ffffff",
          surface: "#000000",
          primary: "#e7541e",
          "primary-darken-1": "#3700B3",
          secondary: "#e7541e",
          "secondary-darken-1": "#018786",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
      },
      jigsawSidebar: {
        dark: false,
        colors: {
          background: "#1D2939",
          surface: "1D2939",
          // primary: "#e7541e",
          accent: "#FFFFFF",
          "surface-bright": "#e7541e",
          "surface-light": "#e7541e",
          "surface-variant": "#e7541e",
          "on-surface-variant": "#e7541e",
        },
        variables: {
          "activated-opacity": 1,
          "high-emphasis-opacity": 1,
          "medium-emphasis-opacity": 0.6,
          "disabled-opacity": 0.38,
          "idle-opacity": 0.04,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          // "activated-opacity": 0.12,
          "pressed-opacity": 0.12,
          "dragged-opacity": 0.08,
        },
      },
      jigsawLight: {
        dark: false,
        colors: {
          background: "#ffffff",
          surface: "#ffffff",
          primary: "#e7541e",
          "primary-darken-1": "#3700B3",
          secondary: "#e7541e",
          "secondary-darken-1": "#018786",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
      },
      jigsawNew: {
        dark: false,
        colors: {
          background: "#E4E7EC",
          surface: "#FFFFFF",
          primary: "#e7541e",
          accent: "#FFFFFF",
          "primary-darken-1": "#3700B3",
          secondary: "#e7541e",
          "secondary-darken-1": "#018786",
          "surface-bright": "#a0a2a5",
          "surface-light": "#e7541e",
          "surface-variant": "#888888ff",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
        variables: {
          "activated-opacity": 0.12,
          "high-emphasis-opacity": 1,
          "medium-emphasis-opacity": 0.6,
          "disabled-opacity": 0.38,
          "idle-opacity": 0.04,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          // "activated-opacity": 0.12,
          "pressed-opacity": 0.12,
          "dragged-opacity": 0.08,
        },
      },

      whiteTheme: {
        dark: false,
        colors: {
          background: "#FFFFFF",
          surface: "#FFFFFF",
          primary: "#6200EE",
          "primary-darken-1": "#3700B3",
          secondary: "#03DAC6",
          "secondary-darken-1": "#018786",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
      },
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
